import * as React from "react";
import styled from 'styled-components'

const FormCard = styled.div`
  padding: 20px;
`;

export { FormCard };
